const prefix = 'redgaady-commerce-v1:';
export function accountId(user) { const value = user?.id ?? user?.customerId ?? user?.userId; if (value === undefined || value === null || !String(value).trim())
    throw new Error('Please sign in again to confirm your account.'); return String(value); }
const storageKey = (account, type) => `${prefix}${encodeURIComponent(account)}:${encodeURIComponent(type)}`;
export function readOperation(account, type) {
    if(typeof window==='undefined')return null;
    const raw = window.localStorage.getItem(storageKey(account, type));
    if (!raw)
        return null;
    const record = JSON.parse(raw);
    if (record.account !== account || record.type !== type || !record.key || !record.payload)
        throw new Error('Unable to restore this operation. Please contact support.');
    return record;
}
export function saveOperation(record) { window.localStorage.setItem(storageKey(record.account, record.type), JSON.stringify(record)); window.dispatchEvent(new Event('commerce-recovery-change')); return record; }
export function beginOperation(account, type, payload, context) {
    const existing = readOperation(account, type);
    if (existing)
        return existing;
    if (!window.crypto?.randomUUID)
        throw new Error('Secure payments are unavailable in this browser.');
    requireUnblocked(account,type);
    return saveOperation({ createdAt:new Date().toISOString(), account, type, payload: JSON.parse(JSON.stringify(payload)), ...(context ? { context: JSON.parse(JSON.stringify(context)) } : {}), key: window.crypto.randomUUID() });
}
export function clearOperation(record) { if (readOperation(record.account, record.type)?.key === record.key)
    {window.localStorage.removeItem(storageKey(record.account, record.type));window.dispatchEvent(new Event('commerce-recovery-change'));} }
const running = new Set();
export async function operationLock(account, type, callback) {
    const name = storageKey(account, 'account-operation');
    if (running.has(name))
        throw new Error('This operation is already in progress.');
    running.add(name);
    try {
        if (typeof navigator!=='undefined'&&navigator.locks?.request)
            return await navigator.locks.request(name, { ifAvailable: true }, lock => { if (!lock)
                throw new Error('This payment is open in another tab.'); return callback(); });
        return await callback();
    }
    finally {
        running.delete(name);
    }
}
export function clearAccountOperations(account) { for (let i = window.localStorage.length - 1; i >= 0; i--) {
    const key = window.localStorage.key(i);
    if (key.startsWith(`${prefix}${encodeURIComponent(account)}:`))
        window.localStorage.removeItem(key);
} }

export function blockingOperation(account,type){
 const kinds=type==='checkout'?['topUp','closure']:type==='topUp'?['checkout','closure']:type==='closure'?['checkout','topUp']:[];
 for(const kind of kinds){const record=readOperation(account,kind);if(record)return record;}return null;
}
export function requireUnblocked(account,type){const record=blockingOperation(account,type);if(record)throw new Error('An unfinished '+(record.type==='topUp'?'recharge':record.type==='closure'?'account closure':'booking payment')+' exists. Resolve it before starting a new payment.');}
